import * as XLSX from 'xlsx';

import { normalizeNote } from './normalizeNote';

export const exportToExcel = (data, filename, sheetName = 'Sheet1') => {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  
  // Ajuster la largeur des colonnes
  const maxWidth = 50;
  const colWidths = Object.keys(data[0] || {}).map(key => ({
    wch: Math.min(
      Math.max(
        key.length,
        ...data.map(row => String(row[key] || '').length)
      ),
      maxWidth
    )
  }));
  worksheet['!cols'] = colWidths;
  
  XLSX.writeFile(workbook, filename);
};

export const exportPresencesToExcel = (presences) => {
  const data = presences.map(p => ({
    'Date': new Date(p.date).toLocaleDateString('fr-FR'),
    'Stagiaire': p.stagiaire_nom || '',
    'Centre': p.centre || '',
    'Statut': p.statut,
    'Formateur': p.formateur_nom || '',
    'Tuteur': p.tuteur_nom || ''
  }));
  
  exportToExcel(data, `presences_${new Date().toISOString().split('T')[0]}.xlsx`, 'Présences');
};

export const exportNotesToExcel = (notes, stagiaireName = '') => {
  const data = notes.map(n => ({
    'Date': new Date(n.date).toLocaleDateString('fr-FR'),
    'Catégorie': n.categorie,
    'Item': n.item,
    'Note': `${normalizeNote(n).toFixed(1)}/10`,
    'Niveau': normalizeNote(n) >= 8 ? 'Compétent' : (normalizeNote(n) >= 5 ? 'En cours' : 'Non compétent'),
    'Formateur': n.formateur_nom || ''
  }));
  
  const filename = stagiaireName 
    ? `notes_${stagiaireName}_${new Date().toISOString().split('T')[0]}.xlsx`
    : `notes_${new Date().toISOString().split('T')[0]}.xlsx`;
    
  exportToExcel(data, filename, 'Notes');
};

export const exportStagiairesToExcel = (stagiaires) => {
  const data = stagiaires.map(s => ({
    'Nom': s.user_info?.nom || '',
    'Prénom': s.user_info?.prenom || '',
    'Email': s.user_info?.email || '',
    'Téléphone': s.user_info?.telephone || '',
    'Centre': s.centre_formation || '',
    'Statut': s.statut || '',
    'Date naissance': s.date_naissance || '',
    'Groupe sanguin': s.groupe_sanguin || ''
  }));
  
  exportToExcel(data, `stagiaires_${new Date().toISOString().split('T')[0]}.xlsx`, 'Stagiaires');
};

export const exportHeuresEncadrementToExcel = (heures, stagiaireName = '') => {
  const data = heures.map(h => ({
    'Date': new Date(h.date).toLocaleDateString('fr-FR'),
    'Catégorie': h.categorie,
    'Sous-catégorie': h.sous_categorie,
    'Heures': h.heures,
    'Tuteur': h.tuteur_nom || ''
  }));
  
  const filename = stagiaireName
    ? `heures_encadrement_${stagiaireName}_${new Date().toISOString().split('T')[0]}.xlsx`
    : `heures_encadrement_${new Date().toISOString().split('T')[0]}.xlsx`;
    
  exportToExcel(data, filename, 'Heures Encadrement');
};

export const exportCompetencesToExcel = (competences, stagiaireName = '') => {
  const data = competences.map(c => ({
    'Date': new Date(c.date).toLocaleDateString('fr-FR'),
    'Catégorie': c.categorie,
    'Sous-catégorie': c.sous_categorie,
    'Statut': c.statut,
    'Tuteur': c.tuteur_nom || '',
    'Validation Stagiaire': c.validation_stagiaire ? 'Oui' : 'Non',
    'Validation Entreprise': c.validation_entreprise ? 'Oui' : 'Non'
  }));
  
  const filename = stagiaireName
    ? `competences_${stagiaireName}_${new Date().toISOString().split('T')[0]}.xlsx`
    : `competences_${new Date().toISOString().split('T')[0]}.xlsx`;
    
  exportToExcel(data, filename, 'Compétences');
};

export const exportDashboardStatsToExcel = (stats) => {
  // Feuille 1: Vue d'ensemble
  const overview = [{
    'Total Stagiaires': stats.stagiaires || 0,
    'Total Formateurs': stats.formateurs || 0,
    'Total Tuteurs': stats.tuteurs || 0,
    'Moyenne Générale': stats.moyenne_generale || 0,
    'Total Heures Formation': stats.total_heures || 0,
    'Total Évaluations': stats.total_evaluations || 0
  }];
  
  const wb = XLSX.utils.book_new();
  const ws1 = XLSX.utils.json_to_sheet(overview);
  XLSX.utils.book_append_sheet(wb, ws1, 'Vue Ensemble');
  
  // Feuille 2: Stagiaires par centre
  if (stats.par_centre) {
    const parCentre = Object.entries(stats.par_centre).map(([centre, count]) => ({
      'Centre': centre,
      'Nombre de Stagiaires': count
    }));
    const ws2 = XLSX.utils.json_to_sheet(parCentre);
    XLSX.utils.book_append_sheet(wb, ws2, 'Par Centre');
  }
  
  // Feuille 3: Moyennes par catégorie
  if (stats.moyennes_categories) {
    const moyennes = Object.entries(stats.moyennes_categories).map(([cat, moy]) => ({
      'Catégorie': cat,
      'Moyenne': moy
    }));
    const ws3 = XLSX.utils.json_to_sheet(moyennes);
    XLSX.utils.book_append_sheet(wb, ws3, 'Moyennes');
  }
  
  XLSX.writeFile(wb, `rapport_centre_${new Date().toISOString().split('T')[0]}.xlsx`);
};
